//FakeLastCard.jsx
import InfoIcon from "../assets/icons/info.svg";
import React from "react";
import { useTranslate, T } from "@tolgee/react";
import { useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

function RichHighlight({ text }) {
    const parts = text.split(/<\/?highlight>/g);
    return (
        <>
            {parts.map((p, i) =>
                i % 2 === 1 ? <span key={i} className="text-red-sp">{p}</span> : <React.Fragment key={i}>{p}</React.Fragment>
            )}
        </>
    );
}

export default function FakeLastCtaCard() {
    const { t } = useTranslate();
    const [searchParams, setSearchParams] = useSearchParams();
    const queryClient = useQueryClient(); // <-- add

    const handleClick = () => {
        // one-shot force
        sessionStorage.setItem("englishOnce", "1");

        // optional: reset pagination (doesn't refetch by itself)
        const params = new URLSearchParams(searchParams);
        params.set("currentPage", "0");
        params.set("itemOffset", "0");
        setSearchParams(params);

        // ✅ explicitly refetch the search data now
        queryClient.invalidateQueries({
            predicate: (q) => Array.isArray(q.queryKey) && q.queryKey[0] === "search",
        });
    };
    const raw = t("CantFindAsset", {
        defaultValue: "¿No has encontrado <highlight>lo que buscas?</highlight>",
    });

    return (
        <article
            className="font-roboto text-center bg-grey-1 rounded-[10px] shadow-[-1px_1px_21.2px_rgba(0,0,0,0.2)] w-[342px] h-[150px] lg:h-[264px] lg:w-[185px] flex flex-col items-center"
            aria-label="results suggestion"
        >
            <img className="h-[36px] w-[36px] mt-[15px] lg:mt-[25px]" src={InfoIcon} alt="" />
            <p className="font-bold text-lg lg:text-2xl mt-[14px] px-[18px] !leading-[1.1]">
                <RichHighlight text={raw} />
            </p>
            <button
                type="button"
                onClick={handleClick}
                className="text-sm text-red-sp mt-[12px] lg:mt-[27px] px-[20px] lg:px-[38px] underline underline-offset-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-sp rounded"
            >
                <T keyName="AccessTheGlobalPage" />
            </button>
        </article>
    );
}
